<template>
    <div :class="{ selected }" class="plan">
        <div class="header">Whatsapp</div>
        <div class="plan-price-section">
            <div class="plan-price-details">
                <span :class="{ tl: site.basePrice.currency === 'tl' }" class="amount">{{
                    $_.get(site, "whatsappBasePrice.value", DEFAULT_PRICING.BASIC.tl.price)
                }}</span>
                <i
                    ><i class="slash">/</i>
                    <i class="billed-month"
                        >{{ $t("billing.month") }}
                        <i class="billed-yearly hide"><br />{{ $t("billing.billedMonthToMonth") }}</i></i
                    ></i
                >
            </div>
        </div>
        <!--@click="updateIntegration('whatsapp', true)"-->
        <md-button
            :disabled="selected"
            class="md-raised md-primary w-100"
            style="transform: scale(0.7); font-size: x-large; border-radius: 10%"
            @click="onSelected"
            >{{ $t(selected ? "wp.subscribed" : "wp.subscribe") }}
        </md-button>
        <span class="text-succes">-</span>
        <a-divider>{{ $t("wp.planDetails") }}</a-divider>
        <div class="features">
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.sendReceiveMessage") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.sendReceiveImage") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.sendReceiveAudio") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.sendReceiveGif") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>Location Send & Receive</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.startChat") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.supsisFunctionality") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.onePhoneMultiAgent") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.basicIntegration") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.broadcastMessagesToContactFile") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.broadcastMessageTemplates") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.messageFlow") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.textMessageSupport") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.imageMessageSupport") }}</span>
            </div>
            <div class="feature">
                <a-icon type="check" />
                <span>{{ $t("wp.spamPreventions") }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CONFIG from "../../../config/config";

export default {
    name: "WhatsappBasicPlanCard",
    props: {
        onSelected: {
            type: Function,
            default: () => {},
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters({}),
        ...mapState({
            siteId: (state) => state.site.site._id,
            site: (state) => state.site.site,
            wpInfo: (state) => state.whatsapp.info,
        }),
    },
    data() {
        return {
            DEFAULT_PRICING: CONFIG.PRICING.WHATSAPP,
        };
    },
};
</script>

<style scoped></style>
